import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { childAPI } from '../../api/client';
import { PageHeader } from '../../components/UI';
import T from '../../theme';

function getStatus(child) {
  const s = child.location_status;
  if (s === 'no_signal') return { label: 'Signal yo\'q', color: T.coral, bg: '#FEF2F2', icon: '📡' };
  if (s === 'on_road') return { label: "Yo'lda", color: T.orange, bg: '#FFF7ED', icon: '🚶' };
  if (s && s.startsWith('at_zone:') && child.current_zone_info) {
    const z = child.current_zone_info;
    return { label: z.name, color: z.color || T.blue, bg: (z.color || T.blue) + '15', icon: z.icon || '📍' };
  }
  return { label: 'Noma\'lum', color: T.textMuted, bg: '#F3F4F6', icon: '❓' };
}



function ChildCard({ child, onClick }) {
  const [h, setH] = useState(false);
  const loc = child.current_location;
  const dev = child.device_info;
  const bat = dev?.battery_level ?? 0;
  const batC = bat > 50 ? T.blue : bat > 20 ? T.yellow : T.coral;
  const st = getStatus(child);

  return (
    <div onClick={onClick} onMouseEnter={() => setH(true)} onMouseLeave={() => setH(false)} style={{
      background: '#fff', borderRadius: 18, padding: 22, cursor: 'pointer',
      border: `2px solid ${h ? T.blue + '25' : T.border}`,
      boxShadow: h ? T.shadowHover : T.shadow,
      transform: h ? 'translateY(-2px)' : 'none', transition: 'all 0.25s',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
        <div style={{
          width: 52, height: 52, borderRadius: 16,
          background: `linear-gradient(135deg, ${T.blue}, ${T.blueLight})`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 22, color: '#fff', fontWeight: 900,
          boxShadow: '0 4px 14px rgba(16,185,129,0.25)',
        }}>{child.name?.[0]?.toUpperCase() || '?'}</div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 18, fontWeight: 800, color: T.text }}>{child.name}</div>
          <div style={{ fontSize: 13, color: T.textMuted, fontWeight: 600, marginTop: 2 }}>
            {child.age ? `${child.age} yosh` : ''} {child.child_type_display} {dev ? `· ${dev.model_name}` : ''}
          </div>
        </div>
        <span style={{ padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: 800, background: st.bg, color: st.color }}>
          {st.icon} {st.label}
        </span>
      </div>

      <div style={{ background: T.bg, borderRadius: 12, padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <span style={{ fontSize: 16 }}>📍</span>
        <span style={{ fontSize: 13, fontWeight: 700, color: T.textSec, flex: 1 }}>{loc?.address || 'Joylashuv aniqlanmoqda...'}</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        {dev && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ fontSize: 14 }}>🔋</span>
            <div style={{ width: 44, height: 6, borderRadius: 3, background: '#E2E8F0' }}>
              <div style={{ width: `${bat}%`, height: '100%', borderRadius: 3, background: batC }} />
            </div>
            <span style={{ fontSize: 12, fontWeight: 800, color: batC, fontFamily: T.mono }}>{bat}%</span>
          </div>
        )}
        {child.zones_list && child.zones_list.map(z => <span key={z.id} style={{ fontSize: 12, color: z.color || T.blue, fontWeight: 700 }}>{z.icon} {z.name}</span>)}
        
        {!dev && <span style={{ fontSize: 12, color: T.orange, fontWeight: 700 }}>⚠️ Qurilma biriktirilmagan</span>}
      </div>
    </div>
  );
}

export default function ChildrenPage() {
  const [children, setChildren] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    childAPI.list().then(r => setChildren(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <PageHeader title="👶 Bolalar" subtitle={`${children.length} ta bola`} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <p style={{ fontSize: 14, color: T.textMuted, fontWeight: 600 }}>{children.length} ta bola</p>
        <button onClick={() => navigate('/children/add')} style={{
          padding: '10px 20px', background: `linear-gradient(135deg, ${T.blue}, ${T.blueLight})`,
          color: '#fff', border: 'none', borderRadius: 12, fontSize: 14, fontWeight: 800,
          cursor: 'pointer', fontFamily: T.font, boxShadow: '0 3px 12px rgba(16,185,129,0.3)',
        }}>+ Bola qo'shish</button>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: T.textMuted }}>Yuklanmoqda...</div>
      ) : children.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '80px 20px', background: '#fff', borderRadius: 20, boxShadow: T.shadow }}>
          <div style={{ fontSize: 56, marginBottom: 16 }}>👶</div>
          <h3 style={{ fontSize: 20, fontWeight: 900, color: T.text, marginBottom: 8 }}>Hali bola yo'q</h3>
          <p style={{ fontSize: 15, color: T.textMuted, marginBottom: 24 }}>Bola qo'shing va GPS qurilma biriktiring</p>
          <button onClick={() => navigate('/children/add')} style={{
            padding: '12px 28px', background: `linear-gradient(135deg, ${T.blue}, ${T.blueLight})`,
            color: '#fff', border: 'none', borderRadius: 14, fontSize: 15, fontWeight: 800,
            cursor: 'pointer', fontFamily: T.font,
          }}>+ Bola qo'shish</button>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: 16 }}>
          {children.map(c => (
            <ChildCard key={c.id} child={c} onClick={() => navigate(`/children/${c.id}`)} />
          ))}
        </div>
      )}
    </div>
  );
}
